const initGoyuuReviewNavigation = (root) => {
  const reviewTrack = root.querySelector('[data-review-track]');
  if (!reviewTrack) return;

  root.querySelectorAll('[data-review-nav]').forEach((button) => {
    button.onclick = () => {
      const firstCard = reviewTrack.querySelector('.goyuu-review-card');
      if (!firstCard) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const gap = Number.parseFloat(window.getComputedStyle(reviewTrack).columnGap) || 0;
      const direction = Number.parseInt(button.dataset.reviewNav, 10) || 1;
      const distance = firstCard.getBoundingClientRect().width + gap;

      reviewTrack.scrollBy({
        left: distance * direction,
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    };
  });
};

const initGoyuuHome = (root) => {
  if (!root) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (root.dataset.motionReady === 'true') return;

  root.dataset.motionReady = 'true';
  root.classList.add('is-motion-ready');

  const revealItems = [...root.querySelectorAll('[data-reveal]')];
  const parallaxItems = [...root.querySelectorAll('[data-parallax]')];

  if (reduceMotion) {
    revealItems.forEach((item) => item.classList.add('is-visible'));
    return;
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
    );

    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  if (!parallaxItems.length) return;

  let scheduled = false;
  const updateParallax = () => {
    const viewportCenter = window.innerHeight / 2;

    parallaxItems.forEach((item) => {
      const rect = item.getBoundingClientRect();
      const itemCenter = rect.top + rect.height / 2;
      const offset = Math.max(-14, Math.min(14, (viewportCenter - itemCenter) * 0.025));
      item.style.setProperty('--goyuu-parallax-y', `${offset}px`);
    });

    scheduled = false;
  };

  const requestParallax = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(updateParallax);
  };

  updateParallax();
  window.addEventListener('scroll', requestParallax, { passive: true });
  window.addEventListener('resize', requestParallax);
};

const initAllGoyuuHomes = () => {
  document.querySelectorAll('.goyuu-home').forEach((root) => {
    initGoyuuReviewNavigation(root);
    initGoyuuHome(root);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllGoyuuHomes, { once: true });
} else {
  initAllGoyuuHomes();
}

document.addEventListener('shopify:section:load', initAllGoyuuHomes);
